import type { WebPImageElement } from '../../../../../common/display/imageSource/ImageSource';
import { ImageSource } from '../../../../../common/display/imageSource/ImageSource';
import { useIntl } from '@/i18n/hooks/useIntl';
import { OrderedList } from '@/components/common/display/orderedList/OrderedList';

export interface HowItWorksTabProps {
  serviceName: string;
  image1: string;
  imageWebp1?: WebPImageElement;
  image2: string;
  imageWebp2?: WebPImageElement;
}

const HowItWorksTab = ({ serviceName, image1, imageWebp1, image2, imageWebp2 }: HowItWorksTabProps) => {
  const { t } = useIntl();
  const Item = OrderedList.Item;

  return (
    <div className='margin-bottom-xxl'>
      <OrderedList>
        <Item
          image={
            <ImageSource
              image={image1}
              imageWebp={imageWebp1}
              imageAlt={t({
                id: `benefits.${serviceName}.modal.howItWorks.image1`,
                defaultMessage: 'opened phone',
              })}
              sizes='100px'
            />
          }
          text={t({
            id: `benefits.${serviceName}.modal.howItWorks.paragraph1`,
            defaultMessage:
              'Bei Rechtsproblem und Rechtsfragen in Zusammenhang mit Miet- und Immobilienrecht die ARAG via Telefon oder E-Mail kontaktieren.',
          })}
        />
        <Item
          image={
            <ImageSource
              image={image2}
              imageWebp={imageWebp2}
              imageAlt={t({
                id: `benefits.${serviceName}.modal.howItWorks.image2`,
              })}
              sizes='100px'
            />
          }
          text={t({
            id: `benefits.${serviceName}.modal.howItWorks.paragraph2`,
            defaultMessage: 'Eine telefonische Erstberatung erhalten und eine rechtliche fundierte Meinung einholen.',
          })}
        />
      </OrderedList>
    </div>
  );
};

export default HowItWorksTab;
